import styled, { css } from 'styled-components';

export const ButtonBackground = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: ${theme.color.background.neutral.default}29;
    border-radius: ${theme.border.radius.medium};
  `}
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;
